import React from "react";

import { css } from "@emotion/css";
import {
  desktop,
  laptop,
  tablet,
} from "../../../styles/breakpoints";
import PlaceHolder from "../../../img/jpg/tell-us-placeholder.jpg";
import { useIsMobile } from "./../../../components/helpers/ScreenCheck";
import { useI18n } from "../../../i18n";

const About = () => {
  const { t } = useI18n();
  const isMobile = useIsMobile(1023);
  return (
    <div className={style.container}>
      <video autoPlay loop muted playsInline webkit-playsinline poster={PlaceHolder}>
        <source
        src={isMobile
            ? '/videos/video_for_background_mobile.mp4'
            : '/videos/tell_us_a_bit_about_yourself_background.mp4'
        }
        type="video/mp4"
        />
      </video>
      <div className="content">
        <h3>{t("tech_about_step")}</h3>
        <h2>01</h2>
        <h4>{t("tech_about_tell")}</h4>
        <p>
          {t("tech_about_before")}
        </p>
      </div>
    </div>
  );
};

const style = {
  container: css({
    width: "100%",
    height: 1528,
    position: "relative",

    video: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    ".content": {
      position: "absolute",
      top: 257,
      left: 0,
      right: 0,
      margin: "auto",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: 753,

      h2: {
        color: "#07006b",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 274.51,
        fontStyle: "normal",
        fontWeight: 700,
        opacity: 0.3,
        mixBlendMode: "plus-darker",
        lineHeight: "163px",
        marginBottom: 45,
      },
      h3: {
        color: "#07006b",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 33,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "29px",
        opacity: 0.3,
        mixBlendMode: "plus-darker",
      },
      h4: {
        color: "#000",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 90,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "85px",
        marginBottom: 18,
      },
      p: {
        color: "#202020",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.32,
      },
    },
    [desktop]: {
      height: 909,

      ".content": {
        top: 79,
        maxWidth: 641,

        h2: {
          fontSize: 150,
          lineHeight: "60px",
          marginBottom: 48,
        },
        h3: {
          fontSize: 17,
          lineHeight: "29px",
        },
        h4: {
          fontSize: 74,
          lineHeight: "65px",
          marginBottom: 21,
        },
        p: {
          fontSize: 16,
        },
      },
    },
    [laptop]: {
      height: 1400,
      marginTop: -250,

      ".content": {
        top: 350,
        maxWidth: 567,

        h2: {
          fontSize: 150,
          lineHeight: "60px",
          marginBottom: 70,
        },
        h3: {
          fontSize: 17,
          lineHeight: "29px",
        },
        h4: {
          fontSize: 60,
          lineHeight: "48px",
          marginBottom: 24,
        },
        p: {
          fontSize: 16,
        },
      },
    },
    [tablet]: {
      height: 1400,
      overflow: 'hidden',

      video: {
        marginTop: -100,
        width: '100%',
        height: '110%'
      },

      ".content": {
        top: 250,
        maxWidth: 335,

        h2: {
          fontSize: 155,
          lineHeight: "155px",
          marginBottom: 20,
        },
        h3: {
          fontSize: 20,
          lineHeight: "30px",
        },
        h4: {
          fontSize: 42,
          lineHeight: "50px",
          marginBottom: 18,
        },
        p: {
          fontSize: 16,
        },
      },
    },
  }),
};

export default About;
